import Model, { hasMany } from "@ember-data/model";
import type ModelRegistry from "@ember-data/types/registries/model";
export default class ConsultationReportType extends Model {
  @hasMany("follow-up-reason", { async: false, inverse: "therapeuticalArea" })
  declare followUpReasons: Array<ModelRegistry["follow-up-reason"]>;
}

declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "consultation-report-type": ConsultationReportType;
  }
}
